module.exports = __webpack_public_path__ + "static/media/trash.593c7e3e.svg";